var map = {
	"./bfy-logo.svg": "99ee",
	"./flags/en.png": "d615",
	"./flags/tr.png": "cbed",
	"./macellan-logo.svg": "26fb",
	"./oski-logo.jpg": "360d",
	"./trianglify-bw-50@2x.png": "d8e8",
	"./umraniye-logo.png": "9435"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";